import "./lib/domGuard";
import "./lib/signupAttribution";
import React from "react";
import ReactDOM from "react-dom/client";
import "@brand";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
